"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DropdownSelectizeGroup = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ChevronDown = _interopRequireDefault(require("@insided/shared/icons/ChevronDown"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _index = _interopRequireDefault(require("./index"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * DropdownSelectizeGroup component handles selecting an item from grouped options
 *
 * In the future, this will support dependency injection for custom tag renderers
 */
var DropdownSelectizeGroup = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(DropdownSelectizeGroup, _Component);

  var _super = _createSuper(DropdownSelectizeGroup);

  function DropdownSelectizeGroup() {
    (0, _classCallCheck2.default)(this, DropdownSelectizeGroup);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(DropdownSelectizeGroup, [{
    key: "onSelect",
    value: function onSelect(item) {
      this.props.onUpdate(item.value);
    }
  }, {
    key: "getSelectedItem",
    value: function getSelectedItem() {
      var _this = this;

      var selected = null;
      this.props.optgroup.forEach(function (group) {
        group.items.forEach(function (item) {
          if (item.value !== _this.props.selectedValue) return;
          selected = item;
        });
      });
      return selected;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$getSelectedItem,
          _this$getSelectedItem2,
          _this2 = this;

      var _this$props = this.props,
          placeholder = _this$props.placeholder,
          _this$props$dropdownT = _this$props.dropdownTriggerTabIndex,
          dropdownTriggerTabIndex = _this$props$dropdownT === void 0 ? 0 : _this$props$dropdownT,
          newStyle = _this$props.newStyle,
          _this$props$dropdownI = _this$props.dropdownItemsTabIndex,
          dropdownItemsTabIndex = _this$props$dropdownI === void 0 ? 0 : _this$props$dropdownI,
          _this$props$hasError = _this$props.hasError,
          hasError = _this$props$hasError === void 0 ? false : _this$props$hasError;
      var selectedLabel = (_this$getSelectedItem = (_this$getSelectedItem2 = this.getSelectedItem()) === null || _this$getSelectedItem2 === void 0 ? void 0 : _this$getSelectedItem2.label) !== null && _this$getSelectedItem !== void 0 ? _this$getSelectedItem : placeholder;

      var DropdownTrigger = function DropdownTrigger(props) {
        if (newStyle) {
          return (0, _preact.h)(_Button.default, {
            title: (0, _preact.h)("div", null, selectedLabel, (0, _preact.h)(_ChevronDown.default, {
              height: 16,
              width: 16
            })),
            size: "medium",
            className: "button-control--dropdown",
            onClick: props.onClick
          });
        }

        return (0, _preact.h)("div", {
          role: "button",
          tabIndex: dropdownTriggerTabIndex,
          className: (0, _classnames.default)('selectize-input', {
            'has-error': hasError
          }),
          onClick: props.onClick,
          onKeyDown: function onKeyDown(e) {
            return e.key === 'Enter' && props.onClick(e);
          }
        }, (0, _preact.h)("div", {
          className: "item"
        }, selectedLabel));
      };

      return (0, _preact.h)("div", {
        className: (0, _classnames.default)('selectize-control', 'single', this.props.className)
      }, (0, _preact.h)(_index.default, {
        popupName: "dropdown-selectize",
        closeOnDropdownClick: true,
        triggerElement: DropdownTrigger,
        class: (0, _classnames.default)('selectize-dropdown', 'single', this.props.className, 'preact-selectize-dropdown')
      }, (0, _preact.h)("div", {
        className: "selectize-dropdown-content"
      }, this.props.optgroup.map(function (group, index) {
        return (0, _preact.h)("div", {
          key: index,
          className: "optgroup"
        }, (0, _preact.h)("div", {
          className: "optgroup-header"
        }, group.label), group.items.map(function (item, index) {
          return (0, _preact.h)("div", {
            role: "button",
            tabIndex: dropdownItemsTabIndex,
            key: index,
            className: "option",
            "data-selectable": true,
            "data-value": item.value,
            onClick: function onClick() {
              return _this2.onSelect(item);
            }
          }, item.label);
        }));
      }))));
    }
  }]);
  return DropdownSelectizeGroup;
}(_preact.Component);

exports.DropdownSelectizeGroup = DropdownSelectizeGroup;
var _default = DropdownSelectizeGroup;
exports.default = _default;